import api from '../auth';
const slug = 'api/valutas/';

const ValutaService = () => {
    const getValutas = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getValutasLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getValuta = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteValuta = (id) => {
        return api
            .delete(slug + `valuta/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createValuta = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateValuta = (id, data) => {
        return api.put(slug + `valuta/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyValuta = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getValutas,
        getValutasLazy,
        getValuta,
        deleteValuta,
        createValuta,
        updateValuta,
        getOptions,
        copyValuta
    };
};

export default ValutaService;
